var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXlmCryptoCryptocurrencyCryptocurrenciesCashMoneyBankPayment95540(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#14B6E7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M12.779 13.527a172.718 172.718 0 0 1 2.11-3.656c2.103-3.533 7.724-3.9 8.03-3.68l-.003.006.004-.004c.306.22 1.86 5.75-.688 8.962a170.192 170.192 0 0 1-2.641 3.241c.93 1.462 1.564 3.931-.625 7.411-.104.164-.3.298-.315-.042-.034-.829-.323-2.477-1.903-4.017l-.1.118c-.485.584-.889.505-1.556.025l-.053-.039c-.076.286-.201.563-.377.819-.02.028-.042.054-.063.082-1.48 2.083-3.567 3.108-4.705 2.286-1.138-.82-.9-3.178.518-5.306.019-.03.035-.06.055-.09.175-.253.385-.465.62-.634h-.001c-.667-.481-.875-.843-.501-1.507l.053-.096c-1.952-.953-3.57-.67-4.352-.423-.325.103-.266-.133-.146-.29 2.472-3.223 4.95-3.522 6.639-3.166zm-1.046 5.947a1.823 1.823 0 0 0-.254.29c-.014.02-.025.04-.038.06-1 1.465-1.175 3.081-.382 3.64.792.557 2.254-.152 3.296-1.586.015-.02.031-.037.045-.057.069-.097.126-.199.173-.303L13.09 20.45l-1.356-.976zm4.932-8.77a2.337 2.337 0 0 0 .549 3.219 2.245 2.245 0 0 0 3.164-.558 2.336 2.336 0 0 0-.55-3.22 2.245 2.245 0 0 0-3.163.559z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXlmCryptoCryptocurrencyCryptocurrenciesCashMoneyBankPayment95540);
export default __webpack_public_path__ + "static/media/xlm-crypto-cryptocurrency-cryptocurrencies-cash-money-bank-payment_95540.f7c91c321d1c66ddf6daf742e2a638c6.svg";
export { ForwardRef as ReactComponent };